import { useMemo } from 'react';
import { ColumnFiltersState } from '@tanstack/react-table';

export const doesFilterHaveValue = (filterValue: unknown) => {
	// null is a valid intentional filter value - only undefined and empty string mean "no filter applied"
	if (filterValue === undefined || filterValue === '') {
		return false;
	}
	// for date range filters (arrays), check if all filterValues are null/empty ie the date has been cleared [null, null]
	if (Array.isArray(filterValue)) {
		return !filterValue.every((v) => v == null || v === '');
	}
	return true;
};

/**
 * Hook to determine if any meaningful filters are applied.
 * Filters out empty date ranges (arrays with all null/empty values).
 */
export const useIsFiltersApplied = (
	columnFilters: ColumnFiltersState,
	globalSearchString?: string
): boolean => {
	return useMemo(() => {
		// check if any filters are meaningful (not empty date ranges)
		const hasMeaningfulFilters = columnFilters.some((filter) =>
			doesFilterHaveValue(filter.value)
		);
		return hasMeaningfulFilters || !!globalSearchString?.length;
	}, [columnFilters, globalSearchString]);
};
